import {
	defaultProductResultDto,
	ProductResultDto,
} from "src/dtos/productResult/ProductResultDto";
import {
	defaultTqcInspectResultDtlDto,
	TqcInspectResultDtlDto,
} from "src/dtos/tqcInspectResult/tqcInspectResultDto";
import { formatDate } from "src/utils/string/stringUtil";

export type KSK2040_R01ValueType = "NUMERIC" | "TEXT" | "PASS_FAIL";
export const KSK2040_R01_INSPECT_TYPE = "FML";
export const KSK2040_R01_VALUE_FIELDS = [
	"inspectValue1_1",
	"inspectValue1_2",
	"inspectValue1_3",
	"inspectValue1_4",
	"inspectValue1_5",
] as const;
export type KSK2040_R01InspectionValueField = typeof KSK2040_R01_VALUE_FIELDS[number];

export interface KSK2040_R01Dto {
	header: KSK2040_R01HeaderDto;
	detailList: KSK2040_R01DetailDto[];
}

export interface KSK2040_R01HeaderDto extends ProductResultDto {
	itemGroup: string;
	jobTeamNm: string;
	inspectionCount: number;
	inspectNo: string;
	inspectType: string;
	inspectTypeNm: string;
	inspectDt: string | undefined;
	inspectorEmp: string;
	inspectorEmpNm: string;
	approvorEmpno: string;
	approvorEmpNm: string;
	inspectRemark: string;
}

export interface KSK2040_R01DetailDto extends TqcInspectResultDtlDto {
	inspItemGroup: string;
	inspType: string;
	inspItemNm: string;
	specValue1: string;
	specRange: string;
	specRangeNm: string;
	specValue2: string;
	inspUnit: string;
	valueType: KSK2040_R01ValueType | "";
	valueTypeNm: string;
	inspMethod: string;
	inspMethodNm: string;
	specRemark: string;
	inserted: boolean;
	isModified: boolean;
}

export const defaultKSK2040_R01HeaderDto: KSK2040_R01HeaderDto = {
	...defaultProductResultDto,
	productOrderNo: "",
	itemGroup: "",
	jobTeamNm: "",
	inspectionCount: 0,
	inspectNo: "",
	inspectType: KSK2040_R01_INSPECT_TYPE,
	inspectTypeNm: "",
	inspectDt: formatDate(new Date()),
	inspectorEmp: "",
	inspectorEmpNm: "",
	approvorEmpno: "",
	approvorEmpNm: "",
	inspectRemark: "",
};

export const defaultKSK2040_R01DetailDto: KSK2040_R01DetailDto = {
	...defaultTqcInspectResultDtlDto,
	inspItemGroup: "",
	inspType: "",
	inspItemNm: "",
	specValue1: "",
	specRange: "",
	specRangeNm: "",
	specValue2: "",
	inspUnit: "",
	valueType: "",
	valueTypeNm: "",
	inspMethod: "",
	inspMethodNm: "",
	specRemark: "",
	inserted: false,
	isModified: false,
};

export const defaultKSK2040_R01Dto: KSK2040_R01Dto = {
	header: defaultKSK2040_R01HeaderDto,
	detailList: [],
};
